import React, { useState, useEffect, useRef } from "react";
import './classes/Login.css';
import { configData } from "../config";
import { Helmet } from 'react-helmet';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

const Login = () => {

    const [formData, setFormData] = useState({
        username: '',
        password: '',
    });
    const app_url = configData.APP_URL;
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleLogin = async event => {
        event.preventDefault();
        // if (validate()) {
            const payload = formData;
            try {
                const res = await fetch(
                    app_url + "site/loginapi",
                    {
                        method: "POST",
                        headers: {
                        "Content-Type": "application/json"
                        },
                        body: JSON.stringify(payload)
                    }
                );
                const data = await res.json();
                if (data.success) {
                alert("Saved successfully");
                // window.location.href="/purchase-order";
                } else {
                alert("Failed to save");
                }
            } catch (err) {
                console.error(err);
            }
        // }
    };


    return (
        <div className="pos-main">
            <Helmet><title>Login</title></Helmet>
            <div className="login-main">
                <div className="login-container">
                    <div className="login-head-container">
                        <img src="/images/logo (2).png" className="login-logo" />
                        <h2 className="login-heading">Welcome Back</h2>
                        <p className="login-sub-head">Sign in to your account</p>
                    </div>

                    {Object.keys(errors).length > 0 && (
                        <div className="login-error-message-container">
                            {Object.keys(errors).map((item, index) => {
                                return <>
                                    <p className="login-error-message">
                                        <FontAwesomeIcon icon={faExclamationCircle} className="login-error-message-icon" />
                                        <span dangerouslySetInnerHTML={{__html: errors[item]}}></span>
                                    </p></>
                            })}  
                        </div>
                    )}
                    <form onSubmit={handleLogin}>
                        <div className="login-form-field">
                            <label htmlFor="username">
                                Username
                            </label>
                            <div className="login-input-container">
                                <span className="login-input-icon-container">
                                    <FontAwesomeIcon icon={faUser} />
                                </span>
                                <input
                                    id="username" 
                                    type="text" 
                                    name="username" 
                                    placeholder="Enter your username" 
                                    required
                                    tabIndex={1}
                                    onChange={handleChange}
                                    value={formData.username}
                                />
                            </div>
                        </div>
                        <div className="login-form-field">
                            <label htmlFor="password">
                                Password
                            </label>
                            <div className="login-input-container">
                                <span className="login-input-icon-container">
                                    <FontAwesomeIcon icon={faLock} />
                                </span>
                                <input 
                                    id="password" 
                                    type="password" 
                                    name="password" 
                                    placeholder="••••••••" 
                                    required
                                    tabIndex={1}
                                    onChange={handleChange}
                                    value={formData.password}
                                />
                            </div>
                        </div>

                        <button 
                            type="submit" 
                            className="login-form-submit"
                        >
                            Sign In
                        </button>
                    </form>
                    <div className="login-info-content">
                        © 2026 ShopLite Cloud. All rights reserved.
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Login;